module.exports = __webpack_public_path__ + "static/media/icon192.ea55d7c2.png";